export enum ButtonStyle {
  Primary = 'primary',
  Secondary = 'secondary',
  Link = 'link',
  NoLink = 'no-link'
}
